import { IonGrid, IonRow } from '@ionic/react'
import notFoundImg from '../assets/images/not-found.svg'
import empty from '../assets/images/Empty.svg'

interface Props {
  type?: string
}

const NoData = ({ type }: Props) => {
  const noResults = (
    <IonRow className="ion-justify-content-center prospectos-placeholder">
      <img src={notFoundImg} style={{ height: '143px' }} />
      <h3 className="not-found-title">No se encontraron resultados para ésta búsqueda</h3>
      <h5 className="not-found-subtitle">¡Intentá nuevamente!</h5>
    </IonRow>
  )
  const emptyProspectos = (
    <IonRow className="ion-justify-content-center prospectos-placeholder">
      <img src={empty} style={{ height: '143px' }} />
      <h3 className="not-found-title">Aún no hay referidos cargados</h3>
      <h5 className="not-found-subtitle">¡Comenzá ahora!</h5>
    </IonRow>
  )
  return (
    <IonGrid className="ion-text-center min-height-not-found grid-col ion-justify-content-between ion-align-items-center">
      <IonRow></IonRow>
      {type === 'empty' ? emptyProspectos : noResults}
      <IonRow></IonRow>
    </IonGrid>
  )
}

export default NoData
